import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-150">
          <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-6" data-id="element-151">
            <AlertCircle className="w-8 h-8 text-red-500" data-id="element-152" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-153">
            EL ERROR DE LA PASTILLA AZUL
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3 mb-12" data-id="element-154">
          {['Las pastillas no crean erecciones; fuerzan una dilatación química que castiga tu corazón y te vuelve dependiente.', 'Los suplementos naturales de farmacia rara vez tienen la concentración necesaria para generar un cambio real.', 'Intentar relajarte es imposible cuando tu cerebro ya ha entrado en pánico por miedo a fallar.'].map((text, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-slate-950 p-6 rounded-2xl border border-slate-800 flex flex-col items-center text-center" data-id="element-155">
              <XCircle className="w-8 h-8 text-slate-600 mb-4" data-id="element-156" />
              <p className="text-slate-300 leading-relaxed" data-id="element-157">{text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-blue-900/20 border border-blue-500/30 p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-158">
          <div className="absolute top-0 left-0 w-1 h-full bg-blue-500" data-id="element-159"></div>
          <p className="text-xl md:text-2xl font-semibold text-blue-100 leading-relaxed" data-id="element-160">
            El 90% de los hombres ignora que la clave de la firmeza no está en
            la testosterona, sino en una molécula llamada{' '}
            <span className="text-blue-400 font-bold" data-id="element-161">Óxido Nítrico</span> que
            ya vive en sus arterias.
          </p>
        </motion.div>
      </div>
    </section>;
}